"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGatewayEnhancedLogDownloadRequest extends new_item_1.default {
    constructor(newGatewayEnhancedLogDownloadRequest) {
        super();
        this.gatewayId = newGatewayEnhancedLogDownloadRequest.gatewayId;
    }
}
exports.default = NewGatewayEnhancedLogDownloadRequest;
//# sourceMappingURL=new-gatewayEnhancedLogDownloadRequest.js.map